module.exports = __webpack_public_path__ + "img/Enalp_80X30.4da05f3b.png";